/* RESPONSIBLE TEAM: team-ml */
import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class AutomationFinAIAgentDataConnectorsRoute extends Route {
  reactEnabled() {
    return true;
  }
}

export default ReactRoute(AutomationFinAIAgentDataConnectorsRoute, {
  overrideRenderTemplate: false,
});
